import facebookIcon from '@propertypal/shared/src/resources/icons/social/facebook.svg?url';
import instagramIcon from '@propertypal/shared/src/resources/icons/social/instagram.svg?url';
import linkedInIcon from '@propertypal/shared/src/resources/icons/social/linkedin.svg?url';
import tikTokIcon from '@propertypal/shared/src/resources/icons/social/tiktok.svg?url';
import twitterIcon from '@propertypal/shared/src/resources/icons/social/twitter.svg?url';
import React from 'react';
import SocialLinksContainer, { IconLink } from './SocialLinks.style';

const SocialLinks = () => {
  return (
    <SocialLinksContainer>
      <div>
        <h4>FIND US ON SOCIAL</h4>

        <div>
          <IconLink
            aria-label="Follow PropertyPal on Facebook"
            href="https://www.facebook.com/propertypal"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebookIcon.src} alt="facebook" loading="lazy" />
          </IconLink>

          <IconLink
            aria-label="Follow PropertyPal on Twitter"
            href="https://www.twitter.com/propertypal"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twitterIcon.src} alt="twitter" loading="lazy" />
          </IconLink>

          <IconLink
            aria-label="Follow PropertyPal on Instagram"
            href="https://www.instagram.com/propertypal"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagramIcon.src} alt="twitter" loading="lazy" />
          </IconLink>

          <IconLink
            aria-label="Follow PropertyPal on LinkedIn"
            href="https://www.linkedin.com/company/propertypal-com"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedInIcon.src} alt="twitter" loading="lazy" />
          </IconLink>

          <IconLink
            aria-label="Follow PropertyPal on tiktok"
            href="https://www.tiktok.com/@propertypal"
            target="_blank"
            rel="noreferrer"
          >
            <img src={tikTokIcon.src} alt="twitter" loading="lazy" />
          </IconLink>
        </div>
      </div>
    </SocialLinksContainer>
  );
};

export default SocialLinks;
